/** @format */

import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';

import { DnvMapState, dnvMapReducer, DnvSearchState, dnvSearchReducer, LayerState, layerReducer } from 'dnv-lib';

export * from './application';
export * from './router';
export * from './auth';

import {
	applicationReducer,
	ApplicationState,
	getProblemSourceList,
	getAllUsersList,
	getProblemAssignmentList,
	getRoles,
	getGroupUsers,
	getRoleUsers,
	getProblemPriorityList,
	getProblemReceivedFromList,
} from './application';
import { RouterStateUrl } from './router';
import { AuthState, authReducer } from './auth';

export interface State {
	applicationReducer: ApplicationState;
	routerReducer: RouterReducerState<RouterStateUrl>;
	authReducer: AuthState;
	mapState: DnvMapState;
	layerState: LayerState;
	dnvSearchState: DnvSearchState;
}

// export const reducers: ActionReducerMap<State> = {
export const reducers: any = {
	applicationReducer,
	routerReducer,
	authReducer,
	mapState: dnvMapReducer,
	layerState: layerReducer,
	dnvSearchState: dnvSearchReducer,
};

import { ApplicationEffects } from './application';
import { RouterEffects } from './router';
import { Attachment } from '../models/attachment';
// import { AuthState } from './auth/auth.state';

export const effects: any[] = [ApplicationEffects, RouterEffects];

export const getApplicationState = createFeatureSelector<ApplicationState>('applicationReducer');
export const getAsset = createSelector(getApplicationState, (state: ApplicationState) => state.asset);
export const getStatus = createSelector(getApplicationState, (state: ApplicationState) => state.status);
export const getDashboardView = createSelector(getApplicationState, (state: ApplicationState) => state.dashboardView);
export const getDashboardTabView = createSelector(getApplicationState, (state: ApplicationState) => state.dashboardTabView);

export const getProblems = createSelector(getApplicationState, (state: ApplicationState) => state.problems);

export const getRecentProblems = createSelector(getApplicationState, (state: ApplicationState) => state.recentProblems);

export const getProblemNeighbors = createSelector(getApplicationState, (state: ApplicationState) => state.problemNeighbors);

export const getProblemNeighborScope = createSelector(getApplicationState, (state: ApplicationState) => state.problemNeighborScope);

export const getDashboardProblems = createSelector(getApplicationState, (state: ApplicationState) => state.problemDashboard);

export const getProblemsFiltered = createSelector(getApplicationState, (state: ApplicationState) => state.problemsFiltered);

export const getLinkedCases = createSelector(getApplicationState, (state: ApplicationState) => state.linkedCases);

export const getProfilePicture = createSelector(getApplicationState, (state: ApplicationState) => state.profilePicture);

export const getLinkedCasesAddMenu = createSelector(getApplicationState, (state: ApplicationState) => state.linkedCasesAddMenu);

export const getProblemsLength = createSelector(getApplicationState, (state: ApplicationState) => (state.problems.length > 1 ? true : false));

export const getActivities = createSelector(getApplicationState, (state: ApplicationState) => state.activities);
export const getMenus = createSelector(getApplicationState, (state: ApplicationState) => state.menu);

export const getDictionaries = createSelector(getApplicationState, (state: ApplicationState) => state.menuDictionaries);

export const getSelectedProblem = createSelector(getApplicationState, (state: ApplicationState) => state.selectedProblem);
export const getProblemHistory = createSelector(getApplicationState, (state: ApplicationState) => state.problemHistory);
export const getNoPin = createSelector(getApplicationState, (state: ApplicationState) => state.noPin);

export const getNoProblems = createSelector(getApplicationState, (state: ApplicationState) => state.noProblems);

export const getGalleryOptions = createSelector(getApplicationState, (state: ApplicationState) => state.galleryOptions);

export const getGalleryImages = createSelector(getApplicationState, (state: ApplicationState) => state.galleryImages);

/* export const getCategorySubTypes = createSelector(
  getApplicationState,
  (state: ApplicationState) => state.categorySubType
); */

export const getSelectedProblemType = createSelector(getApplicationState, (state: ApplicationState) => state.selectedProblemType);

export const getSelectedProblemSubTypes = createSelector(getApplicationState, (state: ApplicationState) => state.problemSubTypes);

export const getNewCaseMenu = createSelector(getApplicationState, (state: ApplicationState) => state.newCaseMenu);

export const getRedirectPath = createSelector(getApplicationState, (state: ApplicationState) => state.redirectPath);

export const getProblemSources = createSelector(getMenus, getProblemSourceList);

export const getProblemReceivedFrom = createSelector(getMenus, getProblemReceivedFromList);

export const getProblemPriorities = createSelector(getMenus, getProblemPriorityList);

export const getAllUsers = createSelector(getMenus, getAllUsersList);

export const getProblemAssignments = createSelector(getMenus, getProblemAssignmentList);

export const getRapUsers = createSelector(getApplicationState, (state: ApplicationState) => state.rapUsers);

export const getDescriptionHistory = createSelector(getApplicationState, (state: ApplicationState) => state.descriptionHistory);

export const getProblemContacts = createSelector(getApplicationState, (state: ApplicationState) => state.problemContacts);

export const getSearchCoordinate = createSelector(getApplicationState, (state: ApplicationState) => state.searchCoordinate);

export const getPropertyOwners = createSelector(getApplicationState, (state: ApplicationState) => state.propertyOwners);

export const getProblemAttachments = createSelector(getApplicationState, (state: ApplicationState) => state.attachments);

export const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('routerReducer');
export const getAuthState = createFeatureSelector<AuthState>('authReducer');

// dnv-lib - DnvMapState
export const getMapState = createFeatureSelector<DnvMapState>('mapState');
export const getLayerState = createFeatureSelector<LayerState>('layerState');
export const getMarkers = createSelector(getMapState, (state: DnvMapState) => state.markers);

export const getSearchResults = createSelector(getApplicationState, (state: ApplicationState) => state.searchResults);

export const getSavedSearchQueries = createSelector(getApplicationState, (state: ApplicationState) => state.savedSearchQueries);

export const getDnvSearchState = createFeatureSelector<DnvSearchState>('dnvSearchState');

export const getTasksLength = createSelector(getApplicationState, (state: ApplicationState) => (state.tasks.length > 1 ? true : false));

export const getTasks = createSelector(getApplicationState, (state: ApplicationState) => state.tasks);

export const getAdmin = createSelector(getApplicationState, (state: ApplicationState) => state.admin);

export const getIsAdminUser = createSelector(getApplicationState, (state: ApplicationState) => state.admin.isAdmin);

export const getProblemRoleList = createSelector(getMenus, getRoles);

export const getGroupUsersList = createSelector(getMenus, getGroupUsers);

export const getUserRolesList = createSelector(getMenus, getRoleUsers);

export const getCityworksTransferMapping = createSelector(getApplicationState, (state: ApplicationState) => state.cityworksTransferMapping);

export const getTransferringToCityworks = createSelector(getApplicationState, (state: ApplicationState) => state.transferringToCityworks);

export const getRequestedCityworksView = createSelector(getApplicationState, (state: ApplicationState) => state.cityworksRequestedView);

export const getIsGettingCityworksViewData = createSelector(getApplicationState, (state: ApplicationState) => state.isGettingCityworksViewData);

export const getCreatingCodeCase = createSelector(getApplicationState, (state: ApplicationState) => state.creatingCodeCase);

export const getInProgressActivity = createSelector(getApplicationState, (state: ApplicationState) => state.inProgressActivity);

export const getInProgressMyTask = createSelector(getApplicationState, (state: ApplicationState) => state.inProgressMyTask);

export const getScrollToResults = createSelector(getApplicationState, (state: ApplicationState) => state.scrollToResults);

export const getAppView = createSelector(getApplicationState, (state: ApplicationState) => state.appView);

export const getViewLoading = createSelector(getApplicationState, (state: ApplicationState) => state.viewLoading);

export const getAttachemntImages = createSelector(getApplicationState, (state: ApplicationState) => state.galleryImages);
